import React from "react";
import { Box } from "@mui/joy";
import JSONPretty from 'react-json-pretty'
import { useFormContext } from "react-hook-form"

const WidgetMapping = ({ className }) => {

    const { getValues } = useFormContext();
    const data = getValues('mapping');

    return (
        <>
            <Box className={"form-element importer-data " + className} sx={{ overflow: 'hidden' }}>
                {data &&
                    <JSONPretty data={data} className="json-wrapper" />
                }
            </Box>
        </>
    );
};

export default WidgetMapping;